import type { CloudMaterial, TemporaryMaterial } from '../../../features/materials/materialsSlice';
import type { CropState, AspectRatio } from './editing/ImageEditCanvas';
import type { MaterialScenario } from '../../../features/materials/api';

export type MaterialData = (CloudMaterial | TemporaryMaterial) & {
  relatedScenarios?: MaterialScenario[];
};

export interface MaterialPreviewModalProps {
  material: MaterialData;
  materialId?: string;
  onClose: () => void;
  onNavigate?: (direction: 1 | -1) => void;
  showEditControls?: boolean;
  showAddToSelectionButton?: boolean;
  showShareButton?: boolean;
  onRequestRefresh?: (materialId: string) => void;
  isTemporary?: boolean;
}

export interface EditState {
  width: number | null;
  height: number | null;
  selectedResolutionId: string | null;
  padding: 'none' | 'white' | 'transparent';
  format: string;
  quality: 'low' | 'medium-low' | 'medium' | 'medium-high' | 'high';
}

export interface SharedMaterialState {
  material: MaterialData;
  notes: string;
  tags: string[];
  isDownloading: boolean;
  isSubmitting: boolean;
  gcsSignedUrl: string | null;
  isTemporaryMaterial: boolean;
}

export interface EditModeState {
  previewJobId: string | null;
  previewImageUrl: string | null;
  cropState: CropState;
  zoom: number;
  naturalSize: { width: number; height: number } | null;
  isPreviewLoading: boolean;
  selectedAspectRatio: AspectRatio;
  editState: EditState;
  isTransformApplied: boolean;
}

export const MIN_ZOOM = 0.05;
export const MAX_ZOOM = 4;
export const ZOOM_STEP = 0.1;
